import { Paper } from '@mui/material';
import React, { PropsWithChildren } from 'react';

// Raised card used to wrap a section of a details page (events, access overview, access, ...).
const SectionPaper: React.FC<PropsWithChildren> = ({ children }) => (
  <Paper elevation={3} sx={{ padding: '24px', borderRadius: 1, width: '100%' }}>
    {children}
  </Paper>
);

export default SectionPaper;
